import { createRouter, createWebHashHistory } from 'vue-router';

import StartView from '@/views/StartView.vue';
import CameraView from '@/views/CameraView.vue';
import CardView from '@/views/CardView.vue';

const routes = [
  { path: '/', name: 'start', component: StartView },
  { path: '/camera', name: 'camera', component: CameraView },
  { path: '/card', name: 'card', component: CardView },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
